export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/88bf19232e48cd6fe29f018005128e1e.png";